export const selectSpecificLocationHandler = (
  option,
  machineIndex,
  extraOption,
  locations,
  isSpecificLocationSelected,
  isMachineSelected,
  specificLocations,
  selectedSpecificLocations
) => {
  // 3. select specific location
  // 3.1 update isSpecificLocationSelected
  
  let index;
  specificLocations.map((el, i) => {
    if (el.includes(extraOption)) {
      return (index = i);
    }
  });
  // clicking the row toggles it, and its machines follow
  const select = !isSpecificLocationSelected[index]?.[machineIndex];

  const isSpecificLocationNewArr = isSpecificLocationSelected[index]?.map(
    (_, idx) => {
      if (idx === machineIndex) {
        return select;
      }
      return _;

    }
  );
  const arr = [...isSpecificLocationSelected];
  
  arr[index] = isSpecificLocationNewArr;

  // 3.2 update isMachineSelected
  // location index
  const locationIndex = locations.indexOf(option);
  const machineNewArr = isMachineSelected[locationIndex][machineIndex]?.map(
    (machine) => select
  );

  const deepCopyArr = JSON.parse(JSON.stringify(isMachineSelected));

  deepCopyArr[locationIndex][machineIndex] = machineNewArr;

  // for dispatch selected specific locations
  let newSelect;
  if (select) {
    newSelect = [...selectedSpecificLocations];
    if (!newSelect.some((el) => el === extraOption)) {
      newSelect.push(extraOption);
    }
  } else {
    newSelect = selectedSpecificLocations.filter((el) => el !== extraOption);
  }

  return {
    specificLocationList: arr,
    machineList: deepCopyArr,
    newSpecificLocations: newSelect,
    select,
    locationIndex,
  };
};
